import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import GoalStaticTableCell from './GoalStaticTableCell';

const GoalStaticsEmpRow = ({ data, headers }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={headers.length + 3} align="center" sx={{ py: 3 }}>
          데이터가 없습니다.
        </TableCell>
      </TableRow>
    );
  }

  const cellStyle = {
    border: '1px solid #e0e0e0',
    fontSize: '0.875rem',
    padding: '8px',
  };
  
  const calculateSum = (items, headerRows) => {
    return headerRows.reduce((acc, field) => {
      const key = typeof field === 'object' ? (field.id || field.key) : field;
      const sum = items.reduce((total, item) => {
        const val = item?.[key];
        const num = (val !== undefined && val !== null && val !== '') ? Number(val) : 0;
        return total + (isNaN(num) ? 0 : num);
      }, 0);
      acc[key] = sum;
      return acc;
    }, {});
  };

  const hqCalculatedTotals = data.map((hq, index) => {
    const isLastRow = index === data.length - 1 || hq.id === 'total';

    if (isLastRow) return null; 

    const dpSubTotalRows = hq.children?.map(dp => 
      dp.children?.find(emp => emp.name === '소계' || emp.id === 'total')
    ).filter(Boolean) || [];

    return calculateSum(dpSubTotalRows, headers);
  });

  const grandTotalValues = calculateSum(hqCalculatedTotals.filter(Boolean), headers);

  return data.map((hq, index) => {
    const isGrandTotalHq = hq.id === 'total' || index === data.length - 1;
    
    const currentTotalValues = isGrandTotalHq ? grandTotalValues : hqCalculatedTotals[index];
    const enrichedHq = { ...hq, ...currentTotalValues };

    const rows = hq?.children?.flatMap((dp, dpIndex) => {
      return dp?.children?.map((emp, empIndex) => {
        const isSubTotal = emp.name === '소계' || emp.id === 'total';

        return (
          <TableRow 
            key={`row-${hq.id}-${dp.id}-${emp.id}`}
            sx={{ backgroundColor: isSubTotal ? '#f9f9f9' : 'inherit' }}
          >
            {dpIndex === 0 && empIndex === 0 && (
              <TableCell align="center" rowSpan={hq.rowSpan} sx={{ ...cellStyle, fontWeight: 'bold', width: '100px', backgroundColor: '#f5f5f5' }}>
                {hq.name}
              </TableCell>
            )}
            {empIndex === 0 && (
              <TableCell align="center" rowSpan={dp.rowSpan} sx={{ ...cellStyle, width: '110px', backgroundColor: '#f5f5f5' }}>
                {dp.name}
              </TableCell>
            )}
            <TableCell align="center" sx={{ ...cellStyle, width: '80px', fontWeight: isSubTotal ? 'bold' : 'normal' }}>
              {emp.name}
            </TableCell>
            <GoalStaticTableCell data={emp} headerRows={headers} />
          </TableRow>
        );
      });
    }) || [];

    const hqTotalRow = (
      <TableRow 
        key={`total-hq-${hq.id}`} 
        sx={{ backgroundColor: isGrandTotalHq ? '#edf2f7' : '#edf2f7' }}
      >
        <TableCell align="center" colSpan={3} sx={{ ...cellStyle, fontWeight: 'bold' }}>
          {hq.id === 'total' ? hq.name : `${hq.name} 소계`}
        </TableCell>
        <GoalStaticTableCell data={enrichedHq} headerRows={headers} />
      </TableRow>
    );

    return [...rows, hqTotalRow];
  });
};

export default GoalStaticsEmpRow;
